/**
 * @lombok/api-client — the single typed gateway between apps/web and the AWS
 * API. It injects the bearer token via an injectable getToken(), parses the
 * shared ApiResponse<T> envelope, and throws ApiError on failure. It holds no
 * secrets and no business authorization — the backend is the authority.
 */
export { ApiClient } from './client';
export type { ApiClientConfig, RequestOptions, TokenProvider } from './client';
export { ApiError, GENERIC_ERROR_MESSAGE_ES } from './errors';
export { createEndpoints } from './endpoints';
export type {
  AgingBucket,
  AgingBuckets,
  AllocatePaymentResult,
  ArAgingItem,
  ArAgingReport,
  ConvertQuoteResult,
  CreateOrderResult,
  DashboardReport,
  HealthResult,
  InventoryQuery,
  InvoicePdfResult,
  InvoicesQuery,
  ListNotificationsResult,
  LombokApi,
  MarkNotificationsReadResult,
  NotificationsQuery,
  OrderDetail,
  OrderReservation,
  OrdersQuery,
  OrderTransitionResult,
  PaymentsQuery,
  PresignUploadResult,
  QuotesQuery,
} from './endpoints';
export { putToPresignedUrl } from './upload';

import { ApiClient, type ApiClientConfig } from './client';
import { createEndpoints, type LombokApi } from './endpoints';

/** A ready-to-use client bundling the low-level ApiClient and typed endpoints. */
export interface LombokApiClient {
  client: ApiClient;
  api: LombokApi;
}

/** Build a configured client + typed endpoint surface in one call. */
export function createLombokApiClient(config: ApiClientConfig): LombokApiClient {
  const client = new ApiClient(config);
  return { client, api: createEndpoints(client) };
}
